<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 1C11.8658 1 15 4.13425 15 8C15 11.8658 11.8658 15 8 15C4.13425 15 1 11.8658 1 8C1 4.13425 4.13425 1 8 1Z"
            fill="#14A687"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.69197 8.95331L11.4705 4.28516L12.8681 5.71579L6.67554 11.7653L3.29297 8.38275L4.70718 6.96853L6.69197 8.95331Z"
            fill="white"
        />
    </svg>
</template>
